export const LOAD_CUSTOM_MEDICAL_TYPES = "LOAD_CUSTOM_MEDICAL_TYPES";
export const LOAD_CUSTOM_MEDICAL_TYPES_SUCCESS = "LOAD_CUSTOM_MEDICAL_TYPES_SUCCESS";
